import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import IconButton from "@mui/material/IconButton";
import { gridDetailPanelExpandedRowsContentCacheSelector, GridRenderCellParams, useGridApiContext, useGridSelector } from "@mui/x-data-grid-premium";
import React, { useEffect } from "react";

interface CustomDetailPanelToggle extends Pick<GridRenderCellParams, "id" | "value"> {
    defaultExpanded?: boolean;
    disabled?: boolean;
    show?: boolean;
    customIcon?: IconDefinition;
    customIconSecondary?: IconDefinition;
}

const CustomDetailPanelToggle: React.FC<CustomDetailPanelToggle> = (props) => {
    const { id, value: isExpanded, disabled, customIcon, customIconSecondary, show = true, defaultExpanded } = props;
    const apiRef = useGridApiContext();

    useEffect(() => {
        if (defaultExpanded && !isExpanded) {
            const currentExpanded = apiRef.current.getExpandedDetailPanels();
            apiRef.current.setExpandedDetailPanels([...currentExpanded, id]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultExpanded, id]);

    // To avoid calling ´getDetailPanelContent` all the time, the following selector
    // gives an object with the detail panel content for each row id.
    const contentCache = useGridSelector(apiRef, gridDetailPanelExpandedRowsContentCacheSelector);

    // If the value is not a valid React element, it means that the row has no detail panel.
    const hasDetail = React.isValidElement(contentCache[id]);

    if (show) {
        return (
            <IconButton size="small" tabIndex={-1} disabled={disabled || !hasDetail} aria-label={isExpanded ? "Close" : "Open"}>
                {isExpanded ? (
                    <FontAwesomeIcon icon={customIconSecondary ? customIconSecondary : MirageTheme.icons.minusIcon} />
                ) : (
                    <FontAwesomeIcon icon={customIcon ? customIcon : MirageTheme.icons.plusIcon} />
                )}
            </IconButton>
        );
    }
    return null;
};

export default CustomDetailPanelToggle;
